import { AVAILABLE_LANGUAGES } from './../App';
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import ko from './locales/ko';
import en from './locales/en';

const defaultLanguage = window.location.hash.split('/')[1] || 'en';

i18n.use(initReactI18next).init({
  resources: {
    ko: { translation: ko },
    en: { translation: en },
  },
  lng: defaultLanguage,
  fallbackLng: 'en',
  supportedLngs: AVAILABLE_LANGUAGES,
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
